import { SSO_CALLBACK_PATH } from "./ssoConfig";

const EXPECTED_CALLBACK_PARAMETERS = new Set([
  "code",
  "state",
  "session_state",
  "error",
  "error_description",
]);

let callbackSnapshot = null;
let captureAttempted = false;
let snapshotConsumed = false;

export function captureSsoCallback(
  location = window.location,
  history = window.history
) {
  if (location.pathname !== SSO_CALLBACK_PATH || captureAttempted) {
    return { active: location.pathname === SSO_CALLBACK_PATH };
  }

  captureAttempted = true;
  const params = new URLSearchParams(location.search || "");
  const unexpectedParameterNames = Array.from(new Set(params.keys())).filter(
    (name) => !EXPECTED_CALLBACK_PARAMETERS.has(name)
  );

  callbackSnapshot = {
    code: params.get("code"),
    state: params.get("state"),
    sessionState: params.get("session_state"),
    error: params.get("error"),
    errorDescription: params.get("error_description"),
    unexpectedParameterNames,
  };

  history.replaceState(history.state, document.title, SSO_CALLBACK_PATH);

  return {
    active: true,
    expectedParameterNames: Array.from(EXPECTED_CALLBACK_PARAMETERS).filter(
      (name) => params.has(name)
    ),
    unexpectedParameterNames,
  };
}

export function consumeSsoCallback() {
  if (!captureAttempted) {
    return { ok: false, reason: "NOT_CAPTURED" };
  }
  if (snapshotConsumed || !callbackSnapshot) {
    return { ok: false, reason: "ALREADY_CONSUMED" };
  }

  snapshotConsumed = true;
  const snapshot = callbackSnapshot;
  callbackSnapshot = null;
  return { ok: true, callback: snapshot };
}

export function resetSsoCallbackBootstrapForTests() {
  callbackSnapshot = null;
  captureAttempted = false;
  snapshotConsumed = false;
}

if (typeof window !== "undefined") {
  captureSsoCallback();
}
